import { mutate } from 'swr';
import { CACHE_KEYS } from '@/constants/cache-keys';
import { AppRoutes } from '@/constants/routes';
import { globalNavigateTo } from '@/lib/global-navigate';

export const RETURN_TO_PARAM = 'returnTo';

const AUTH_PATHS: string[] = [AppRoutes.SIGN_IN, AppRoutes.LOGOUT];

type AppLocation = Pick<Location, 'pathname' | 'search' | 'hash'>;

let isRedirectingToSignIn = false;

export function toSafeReturnTo(raw: string | null): string | null {
    if (!raw?.startsWith('/')) {
        return null;
    }
    const url = new URL(raw, window.location.origin);
    if (
        url.origin !== window.location.origin ||
        AUTH_PATHS.includes(url.pathname)
    ) {
        return null;
    }
    const path = `${url.pathname}${url.search}${url.hash}`;
    return path === AppRoutes.HOME ? null : path;
}

export function buildSignInPath({
    pathname,
    search,
    hash,
}: AppLocation): string {
    const safeReturnTo = toSafeReturnTo(`${pathname}${search}${hash}`);
    if (!safeReturnTo) {
        return AppRoutes.SIGN_IN;
    }
    const params = new URLSearchParams({ [RETURN_TO_PARAM]: safeReturnTo });
    return `${AppRoutes.SIGN_IN}?${params.toString()}`;
}

export function redirectToSignIn(): void {
    if (
        isRedirectingToSignIn ||
        window.location.pathname === AppRoutes.SIGN_IN
    ) {
        return;
    }
    isRedirectingToSignIn = true;
    mutate(CACHE_KEYS.AUTH_USER, null, { revalidate: false });
    globalNavigateTo(buildSignInPath(window.location), { replace: true });
}
